import { AvatarGroup, Box, Icon } from '@ff-it/ui';
import { useRealtimeChannelState, useRealtimeStatus } from 'services';
import { UserAvatar } from './UserAvatar';
import { usePresenceUsers } from './PresenceUsers';

const realtimeStatusIcon: Partial<
  Record<ReturnType<typeof useRealtimeStatus>['status'], React.ComponentProps<typeof Icon>>
> = {
  connected: { icon: 'signal-stream', color: 'success500' },
  connecting: { icon: 'signal-stream', color: 'warning500' },
  reconnecting: { icon: 'signal-stream-slash', color: 'warning500' },
  disconnected: { icon: 'signal-stream-slash', color: 'error500' },
};

export function RealtimeStatus() {
  const { status } = useRealtimeStatus();
  const iconProps = realtimeStatusIcon[status];
  return (
    <Box testId="realtime-status" data-status={status}>
      {iconProps && <Icon {...iconProps} />}
    </Box>
  );
}

export function ChannelSubscribers({ channelKey }: { channelKey: string }) {
  const state = useRealtimeChannelState(channelKey);
  const { users, color } = usePresenceUsers();
  if (state === 'unsubscribed') {
    return null;
  }

  return (
    <Box
      background="brand25"
      borderRadius="xl"
      px="1"
      textSize="xs"
      display="flex"
      alignItems="center"
      testId="realtime-presence"
      data-state={state}
    >
      <Box mr="1">Online</Box>
      <AvatarGroup size="xxs">
        {users.map((user) => (
          <UserAvatar key={user.id} user={user} color={color(user.id)} />
        ))}
      </AvatarGroup>
    </Box>
  );
}
